(function ($, site) {
  Drupal.behaviors.power_of_the_night_formatter_v1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $thismodule = $('.js-power-night-v1', context);
      var $goingOut = $thismodule.find('.power-night__going-out');
      var $stayingIn = $thismodule.find('.power-night__staying-in');
      var $goingOutTiles = $goingOut.find('.power-night__item');
      var $stayingInTiles = $stayingIn.find('.power-night__item');
      var $mppProductsGoingOut;
      var $mppProductsStayingIn;
      var $mppProductGrid;
      var $currentModuleParent;
      var $currentModule;
      var mobileWidth = 767;
      var filterInitiated = false;

      /* Engagement analytics */
      function fireAnalytic(eventAction, eventLabel) {
        site.track.evtLink({
          event_name: 'elOwnTheNight',
          event_category: 'own the night',
          event_action: eventAction,
          event_label: eventLabel
        });
      }

      $goingOutTiles.on('click', function () {
        var tileIndex = $(this).index();

        fireAnalytic('Going-out item ' + tileIndex, 'click');
      });

      $stayingInTiles.on('click', function () {
        var tileIndex = $(this).index();

        fireAnalytic('Staying item ' + tileIndex, 'click');
      });

      function getCurrentModule(moduleName) {
        if (moduleName === 'goingout') {
          $currentModuleParent = $thismodule.find('.power-night__going-out');
          $currentModule = $currentModuleParent.find('.js-power-night__out');
          $mppProductsGoingOut = $currentModuleParent.next('.mpp');
        }
        if (moduleName === 'stayingin') {
          $currentModuleParent = $thismodule.find('.power-night__staying-in');
          $currentModule = $currentModuleParent.find('.js-power-night__out');
          $mppProductsStayingIn = $currentModuleParent.next('.mpp');
        }
      }

      // Retrieve all quickshop containers to wrap the qs panels for mobile
      function getQuickshopContainer(e, $mppProducts, moduleName) {
        var $qsBtn = $(e.currentTarget);
        var $qsGrid = $mppProducts.find('.mpp__product-grid');

        $mppProducts.remove();
        if ($qsGrid.length === 0) {
          // then has already been moved
          if (moduleName === 'goingout') {
            $qsGrid = $goingOut.find('.mpp__product-grid');
          }
          if (moduleName === 'stayingin') {
            $qsGrid = $stayingIn.find('.power-night__item').siblings('.mpp__product-grid');
          }
        }
        $qsGrid.insertAfter($qsBtn.closest('.power-night__item-qs'));
      }

      // Manually appending the quickshop elements to tiles for mobile.
      function appendQuickshopMobile(moduleName) {
        getCurrentModule(moduleName);
        var $mppProducts = $currentModuleParent.next('.mpp');

        $mppProducts.css('opacity', 0);
        var $quickshops = $currentModule.find('.js-quick_shop');

        $.each($quickshops, function (qs_index, qs_value) {
          var $qs = $(qs_value),
            qsProdID;

          if ($qs && $qs.length > 0) {
            qsProdID = $qs.data('product');
            $.each($mppProducts, function (mpp_index, mpp_value) {
              var $mppItem = $(mpp_value);
              var $productBriefs = $mppItem.find('.product-brief');

              $.each($productBriefs, function (product_index, product_value) {
                var $product = $(product_value);

                if ($product && $product.length > 0) {
                  var productProdID = $product.data('product-id');

                  if (productProdID === qsProdID) {
                    $product.insertAfter($qs);
                    $product.find('.js-quickshop-show').once().click(function (e) {
                      jQuery.scrollTo.window().queue([]).stop();
                      if (moduleName === 'goingout') {
                        getQuickshopContainer(e, $mppProductsGoingOut, moduleName);
                      }
                      if (moduleName === 'stayingin') {
                        getQuickshopContainer(e, $mppProductsStayingIn, moduleName);
                      }
                    });
                    $mppProductGrid = $product.find('.js-quickshop-show');
                  }
                }
              });
            });
          }
        });
        var $qsGrid = $mppProducts.find('.mpp__product-grid');

        $mppProducts.remove();
        if ($mppProductGrid && $mppProductGrid.length > 0) {
          $qsGrid.insertAfter($mppProductGrid.closest('.power-night__item-qs'));
        }
      }

      function removeSpinner() {
        var $spinner = $thismodule.find('.boutiques_spinner_v1_target');

        if ($spinner && $spinner.length > 0) {
          $thismodule.find('.boutiques_spinner_v1_target').remove();
        }
      }

      function checkQuickshopMobile() {
        appendQuickshopMobile('goingout');
        appendQuickshopMobile('stayingin');
      }

      function isMobile() {
        var windowWidth = $(window).width();

        if (windowWidth <= mobileWidth) {
          return true;
        }

        return false;
      }

      // Remove any reviews that are unused/empty
      function cleanQuoteList($quotes) {
        $.each($quotes, function (quote_index, quote_value) {
          var $quote = $(quote_value);

          if ($quote.children().length === 0) {
            $quotes.splice(quote_index, 1);
          }
        });

        return $quotes;
      }

      // Animation timer/activation
      function startAnimationTimer($quotes, quoteIndex) {
        var timer = setInterval(function () {
          $quotes.removeClass('active');
          // waits for initial fade out to finish
          setTimeout(function () {
            $quotes.addClass('DisplayOff');
            quoteIndex++;
            var $nextQuote = $($quotes[quoteIndex]);

            $nextQuote.removeClass('DisplayOff');
            setTimeout(function () {
              $nextQuote.addClass('active');
            }, 300);
            if (quoteIndex === $quotes.length - 1) {
              quoteIndex = -1;
            }
          }, 500);
        }, 10800);
      }

      // Loop through all reviews and begin animation
      function startReviewAnimations(isGoingOut) {
        var $reviews = isGoingOut ? $goingOut.find('.power-night__item-overtext--review') : $stayingIn.find('.power-night__item-overtext--review');

        $.each($reviews, function (review_index, review_value) {
          var quoteIndex = 0;
          var $review = $(review_value),
            $quotes = $review.children('.power-night__item-title--review');

          $quotes = cleanQuoteList($quotes);
          startAnimationTimer($quotes, quoteIndex);
        });
      }

      // On moving to the staying in / going out section, begin the review animations
      $thismodule.on('boutique:filter_initiated', function () {
        if (filterInitiated === false) {
          startReviewAnimations(true);
          startReviewAnimations();
          if (isMobile()) {
            checkQuickshopMobile();
          }
          filterInitiated = true;
        }
      });
      removeSpinner();
    }
  };
})(jQuery, site);
